import * as Map from "./map";
export { Map };



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/map/index.ts
// module id = uwTI
// module chunks = 2